module.exports = __webpack_public_path__ + "/login_ui/img/jo-751b1e31f14b372857868b30ab9bb4fe.svg";